var html = require('choo/html')
var Matter = require('matter-js')

var TITLE = 'energy-visuals - main'

module.exports = view

function view (state, emit) {
  if (state.title !== TITLE) emit(state.events.DOMTITLECHANGE, TITLE)

  function renderWorld (n, i, w, h, bg, selector) {
    var Engine = Matter.Engine
    var Render = Matter.Render
    var Runner = Matter.Runner
    var Common = Matter.Common
    var World = Matter.World
    var Bodies = Matter.Bodies

    // create engine
    var engine = Engine.create()
    var world = engine.world

    // create renderer
    var render = Render.create({
      element: document.querySelector(selector),
      engine: engine,
      options: {
        width: w,
        height: h,
        background: bg,
        showAngleIndicator: false,
        wireframes: false
      }
    })

    Render.run(render)

    // create runner
    var runner = Runner.create()
    Runner.run(runner, engine)

    var options = {
      background: bg,
      isStatic: true
    }

    world.bodies = []

    World.add(world, [
      Bodies.rectangle(0, 0, w * 2, 0.01, options),
      Bodies.rectangle(0, h - 0.01, w * 2, 0.01, options),
      Bodies.rectangle(0, 0, 0.01, h * 2, options),
      Bodies.rectangle(w - 0.01, 0, 0.01, h * 2, options)
    ])

    for (var j = 0; j < n; j++) {
      var posX = Common.random() * w
      var posY = Common.random() * h
      let item = Bodies.circle(posX, posY, 15, {
        density: 0.0005,
        frictionAir: 0.06,
        restitution: 0.3,
        friction: 0.01,
        render: {
          sprite: {
            texture: i
          }
        }
      })
      World.add(world, item)
    }

    // fit the render viewport to the scene
    Render.lookAt(render, {
      min: { x: 0, y: 0 },
      max: { x: w, y: h }
    })

    return function () {
      Matter.Render.stop(render)
      Matter.Runner.stop(runner)
    }
  }

  let inputOptions = []
  let outputOptions = []
  let tableRows = []

  for (var key in state.categories) {
    let category = state.categories[key]
    let { name, asset, info, reference, kJ } = category
    inputOptions.push(html`
      <option value='${key}'>${name}</option>
    `)
    outputOptions.push(html`
      <option value='${key}'>${name}</option>
    `)
    tableRows.push(html`
      <tr>
        <td><img src='${asset}'/></td>
        <td>${name}</td>
        <td>${kJ} kJ</td>
        <td>${info}</td>
        <td><a href='${reference}'>${reference}</a></td>
      </tr>
    `)
  }

  let numberInput = html`
    <div class="measure pa1 pt2">
      <label for="numberInput" class="f6 b db mb2">Number</label>
      <input id='numberInput' placeholder='0' onkeyup=${updateState} class="pa1 ba b--black-50 br3 tr input-reset ba w4" type="text">
    </div>
  `
  let inputSelect = html`
  <div class="measure pa2">
    <label for="inputCategory" class="f6 b db mb2">Units</label>
    <select id='inputCategory' onchange=${updateState} class="pa2 mb2 w-100">
      ${inputOptions}
    </select>
    <small id='inputDesc' class="f6 black-60 db mb2"></small>
  </div>
  `

  let outputSelect = html`
    <div class="measure pa2">
      <label for="outputCategory" class="f6 b db mb2">In terms of</label>
      <select id='outputCategory' onchange=${updateState} class="pa2 mb2 db w-100">
        ${outputOptions}
      </select>
      <small id='outputDesc' class="f6 black-60 db mb2"></small>
    </div>

  `

  function updateState () {
    emit('updateState', () => {
      worldRender()
      updateInfo()
    })
  }

  function updateInfo () {
    console.log('hello')
    document.querySelector('#inputDesc').innerHTML = state.input.info
    document.querySelector('#outputDesc').innerHTML = state.output.info
  }

  function worldRender () {
    if (state.stop) { state.stop() }
    let inputEnergy = state.numberInput * state.input.kJ
    let outputUnitEnergy = state.output.kJ
    let n = Math.ceil(inputEnergy / outputUnitEnergy)
    let w = Math.ceil(window.innerWidth / 2)
    let h = Math.floor(window.innerHeight - 300)

    let numInput = state.numberInput
    let inputName = state.input.name
    let outputName = state.output.name

    let renderDescription = '<span class="bg-blue">' + numInput + '</span> x <span class="bg-red">' + inputName + '</span> is roughly equivalent to <span class="bg-green">' + n + '</span> x <span class="bg-yellow">' + outputName + '</span>'
    document.querySelector('#renderDescription').innerHTML = renderDescription

    if (n > 1000) {
      window.alert('Conversion results in too many items to render!')
    } else {
      let inputStop = renderWorld(state.numberInput, state.input.asset, w, h, '#FFDFDF', '#world1')
      let outputStop = renderWorld(n, state.output.asset, w, h, '#FFFCEB', '#world2')
      state.stop = () => {
        inputStop()
        outputStop()
        document.querySelector('#world1').innerHTML = ''
        document.querySelector('#world2').innerHTML = ''
      }
    }
  }

  return html`
    <body class="code lh-copy w-100">
      <style>
        body {
          background-color: #FAFAFA
        }
        a {
          cursor:pointer;
        }
        span {
          padding: 2px 5px;
          margin: 0px 5px;
          background: rgba(0,0,0,0.25);
          border-radius:5px;
        }
        thead td{
          border-bottom: 1px solid rgba(0,0,0,0.3);
          padding: 4px 4px;
        }
        tbody td{
          border-bottom: 1px solid rgba(0,0,0,0.1);
          padding: 4px 4px;
        }
      </style>
      <div class='pa4'>
        <h1>
          \u26A1 Energy equivalence tool
        </h1>
        <p class='silver f5'>
          This tool compares the various energy usages in terms of kilojoules (kJ) of common activities and energy sources.
          The <b>energy equivalence tool</b> was built to <b>interactively</b> demonstrate the differences in "energy" usages in the parts of daily life.<br/>
          <br/>
          This was made primarily using <a href='https://choo.io' class='link blue no-underline'><b>🚂choo</b></a> and <a href='http://brm.io/matter-js/' class='link blue no-underline'><b>▲●■ matter.js</b></a>.
        </p>
      </div>
      <div class="flex flex-wrap w-100">
        <div class="w-50-ns w-100 bg-light-blue">
            <form class='flex flex-wrap form pa4 black-80'>
              ${numberInput}
              ${inputSelect}
            </form>
        </div>
        <div class='w-50-ns w-100 bg-light-green flex flex-wrap items-center'>
            <form class='flex form pa4 black-80'>
              ${outputSelect}
            </form>
          </div>
      </div>
      <div class="flex flex-wrap w-100 relative">
        <div id="world1" class='w-50-ns w-100 abolute bottom-0 bg-washed-red'>
        </div>
        <div id="world2" class='w-50-ns w-100 abolute bottom-0 bg-washed-yellow'>
        </div>
      </div>
      <div id='renderDescription' class="pa4 flex items-center justify-center w-100 bg-light-gray">
      </div>
      <div class="pa4 f5 w-100">
        <h2>
          What do you mean "energy"?
        </h2>
        <p>
          That is an excellent question-- one that was inspected within the Columbia University course "Energy and Energy Conservation" taught by the Dean of Columbia College, James Valentini. 
          Energy is perplexing and unique property of many concepts in our world. In this example we adopt a physical definition of energy, the joule, which is the base measurement unit for energy in the Metric system.
          We then compare the various 'units' above through their known or computed joule values.
        </p>
        <br/>
        <table class='striped w-100'>
          <thead class='w-100'>
            <tr class='bb b--black-30'>
              <td class='w-10'></td>
              <td class='w-30'>Unit</td>
              <td class='w-10'>kJ</td>
              <td class='w-30'>Info</td>
              <td class='w-20'>Reference</td>
            </tr>
          </thead>
          <tbody class='br4'>
            ${tableRows}
          </tbody>
        </table>
      </div>
      <div class="pa4 f5 w-100">
        <h3>
          A note
        </h3>
        <p>
          These values are approximations based on energy content and exists to demonstrate not precise comparisons but general ones!
        </p>
      </div>
      <a class='b ba b--black-20 br-pill f4 grow no-underline dib fixed bottom-2 right-2  ph3 pv2 bg-light-pink dark-pink' href='/' onclick=${updateState}>
          Render
      </a>
    </body>
  `
  
}
